import CircleRoundedIcon from '@mui/icons-material/CircleRounded'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import PersonPinIcon from '@mui/icons-material/PersonPin'
import ReportRoundedIcon from '@mui/icons-material/ReportRounded'
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardHeader,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useNavigate } from 'react-router-dom'

import * as routes from '../../config/constants'
import darkTheme from '../../config/darkTheme'
import theme from '../../config/theme'
import { IsCar } from '../../interfaces/IsCar'
import NumberPlate from '../../shared/NumberPlate'
import { getDevice, getLastPosition } from '../../store/devices'
import { getTheme } from '../../store/ui'
interface IProps {
  car: any
  id: string
  onStatus: any
}

const CarItem: FC<IProps> = ({ car, id, onStatus }) => {
  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const themeApp = useSelector(getTheme)
  // تصاویر مربوط به شرکت های خودروسازی
  const getCarCompany = (companyId: any) => {
    if (companyId < 47) {
      return '/images/saipa.png'
    } else if (companyId === 47 || companyId < 100) {
      return '/images/iran-Khodro.png'
    } else if (companyId === 100 || companyId < 128) {
      return '/images/bahman.png'
    } else if (companyId === 128 || companyId < 146) {
      return '/images/mvm.png'
    } else if (companyId === 146 || companyId < 158) {
      return '/images/chery.png'
    } else if (companyId === 158 || companyId < 166) {
      return '/images/dongFang.png'
    } else if (companyId === 166 || companyId < 249) {
      return '/images/bmw.png'
    } else if (companyId === 249 || companyId < 265) {
      return '/images/jili.png'
    } else if (companyId === 265 || companyId < 274) {
      return '/images/faw.png'
    } else if (companyId === 274 || companyId < 289) {
      return '/images/gratewall.png'
    } else if (companyId === 289 || companyId < 317) {
      return '/images/kerman.png'
    } else if (companyId === 317 || companyId < 329) {
      return '/images/foton.png'
    } else if (companyId === 329 || companyId < 358) {
      return '/images/reno.png'
    } else if (companyId === 358 || companyId < 370) {
      return '/images/pegout.png'
    } else if (companyId === 370 || companyId < 377) {
      return '/images/asna.png'
    } else if (companyId === 377 || companyId < 393) {
      return '/images/jac.png'
    } else if (companyId === 393 || companyId < 405) {
      return '/images/mazda.png'
    } else if (companyId === 405 || companyId < 419) {
      return '/images/lifan.png'
    } else if (companyId === 419 || companyId < 440) {
      return '/images/songyong.png'
    } else if (companyId === 440 || companyId < 496) {
      return '/images/toyota.png'
    } else if (companyId === 496 || companyId < 507) {
      return '/images/zamyad.png'
    } else if (companyId === 507 || companyId < 512) {
      return '/images/huangHia.png'
    } else if (companyId === 512 || companyId < 536) {
      return '/images/kia.png'
    } else if (companyId === 536 || companyId < 547) {
      return '/images/poroton.png'
    } else if (companyId === 547 || companyId < 578) {
      return '/images/hyonda.png'
    } else if (companyId === 578 || companyId < 585) {
      return '/images/citroen.png'
    } else if (companyId === 585 || companyId < 669) {
      return '/images/benz.png'
    } else if (companyId === 669 || companyId < 686) {
      return '/images/mg.png'
    } else if (companyId === 686 || companyId < 696) {
      return '/images/haima.png'
    } else if (companyId === 696 || companyId < 706) {
      return '/images/suzuki.png'
    } else if (companyId === 706 || companyId < 729) {
      return '/images/pars.png'
    } else if (companyId === 729 || companyId < 737) {
      return '/images/changan.png'
    } else if (companyId === 737 || companyId < 743) {
      return '/images/devo.png'
    } else if (companyId === 743 || companyId < 748) {
      return '/images/bayk.png'
    } else if (companyId === 748 || companyId < 759) {
      return '/images/phonix.png'
    } else if (companyId === 759 || companyId < 769) {
      return '/images/farda.png'
    } else if (companyId === 769 || companyId < 774) {
      return '/images/lamari.png'
    } else if (companyId === 774 || companyId < 779) {
      return '/images/rigan.png'
    } else if (companyId === 779 || companyId < 783) {
      return '/images/biso.png'
    } else if (companyId === 783 || companyId < 789) {
      return '/images/byd.png'
    } else if (companyId === 789 || companyId < 792) {
      return '/images/damay.png'
    } else if (companyId === 792 || companyId < 796) {
      return '/images/bogoard.png'
    } else if (companyId === 796 || companyId < 800) {
      return '/images/henteng.png'
    } else if (companyId === 800 || companyId < 804) {
      return '/images/uaz.png'
    } else if (companyId === 804 || companyId < 813) {
      return '/images/hawal.png'
    } else if (companyId === 813 || companyId < 817) {
      return '/images/swm.png'
    } else if (companyId === 817 || companyId < 827) {
      return '/images/folex.png'
    } else if (companyId === 827 || companyId < 841) {
      return '/images/nisan.png'
    } else if (companyId === 841 || companyId < 890) {
      return '/images/mitsu.png'
    }
  }
  const getCarCompany77 = (companyId: string) => {
    switch (companyId) {
      case '1':
        return '/images/saipa.png'
      case '2':
        return '/images/iran-Khodro.png'
      case '3':
        return '/images/bahman.png'
      case '4':
        return '/images/mvm.png'
      case '5':
        return '/images/chery.png'
      case '6':
        return '/images/dongFang.png'
      case '7':
        return '/images/bmw.png'
      case '8':
        return '/images/jili.png'
      case '9':
        return '/images/faw.png'
      case '10':
        return '/images/gratewall.png'
      case '11':
        return '/images/kerman.png'
      case '12':
        return '/images/foton.png'
      case '13':
        return '/images/reno.png'
      case '14':
        return '/images/pegout.png'
      case '15':
        return '/images/asna.png'
      case '16':
        return '/images/jac.png'
      case '17':
        return '/images/mazda.png'
      case '18':
        return '/images/lifan.png'
      case '19':
        return '/images/songyong.png'
      case '20':
        return '/images/toyota.png'
      case '21':
        return '/images/zamyad.png'
      case '22':
        return '/images/huangHia.png'
      case '23':
        return '/images/kia.png'
      case '24':
        return '/images/poroton.png'
      case '25':
        return '/images/hyonda.png'
      case '26':
        return '/images/citroen.png'
      case '27':
        return '/images/benz.png'
      case '28':
        return '/images/mg.png'
      case '29':
        return '/images/haima.png'
      case '30':
        return '/images/suzuki.png'
      case '31':
        return '/images/pars.png'
      case '32':
        return '/images/changan.png'
      case '33':
        return '/images/devo.png'
      case '34':
        return '/images/bayk.png'
      case '35':
        return '/images/phonix.png'
      case '36':
        return '/images/farda.png'
      case '37':
        return '/images/lamari.png'
      case '38':
        return '/images/rigan.png'
      case '39':
        return '/images/biso.png'
      case '40':
        return '/images/byd.png'
      case '41':
        return '/images/damay.png'
      case '42':
        return '/images/bogoard.png'
      case '43':
        return '/images/henteng.png'
      case '44':
        return '/images/uaz.png'
      case '45':
        return '/images/hawal.png'
      case '46':
        return '/images/swm.png'
      case '47':
        return '/images/folex.png'
      case '48':
        return '/images/nisan.png'
      case '49':
        return '/images/mitsu.png'
      default:
        return '/images/logo1.png'
    }
  }
  // اسامی مربوط شرکت های خودروسازی
  const getCarCompany1 = (companyId: any) => {
    if (companyId < 47) {
      return 'سایپا'
    } else if (companyId === 47 || companyId < 100) {
      return 'ایرانخودرو'
    } else if (companyId === 100 || companyId < 128) {
      return 'بهمن'
    } else if (companyId === 128 || companyId < 146) {
      return 'ام وی ام'
    } else if (companyId === 146 || companyId < 158) {
      return 'چری'
    } else if (companyId === 158 || companyId < 166) {
      return 'دانگ فنگ'
    } else if (companyId === 166 || companyId < 249) {
      return 'بی ام و'
    } else if (companyId === 249 || companyId < 265) {
      return 'جیلی'
    } else if (companyId === 265 || companyId < 274) {
      return 'فاو'
    } else if (companyId === 274 || companyId < 289) {
      return 'گریت وال'
    } else if (companyId === 289 || companyId < 317) {
      return 'کرمان موتور'
    } else if (companyId === 317 || companyId < 329) {
      return 'فوتون'
    } else if (companyId === 329 || companyId < 358) {
      return 'رنو'
    } else if (companyId === 358 || companyId < 370) {
      return 'پژو'
    } else if (companyId === 370 || companyId < 377) {
      return 'آسنا'
    } else if (companyId === 377 || companyId < 393) {
      return 'جک'
    } else if (companyId === 393 || companyId < 405) {
      return 'مزدا'
    } else if (companyId === 405 || companyId < 419) {
      return 'لیفان'
    } else if (companyId === 419 || companyId < 440) {
      return 'سانگ یانگ'
    } else if (companyId === 440 || companyId < 496) {
      return 'تویوتا'
    } else if (companyId === 496 || companyId < 507) {
      return 'زامیاد'
    } else if (companyId === 507 || companyId < 512) {
      return 'Huang Hia'
    } else if (companyId === 512 || companyId < 536) {
      return 'کیا'
    } else if (companyId === 536 || companyId < 547) {
      return 'پروتون'
    } else if (companyId === 547 || companyId < 578) {
      return 'هیوندا'
    } else if (companyId === 578 || companyId < 585) {
      return 'سیتروئن'
    } else if (companyId === 585 || companyId < 669) {
      return 'مرسدس بنز'
    } else if (companyId === 669 || companyId < 686) {
      return 'ام جی'
    } else if (companyId === 686 || companyId < 696) {
      return 'هایما'
    } else if (companyId === 696 || companyId < 706) {
      return 'سوزوکی'
    } else if (companyId === 706 || companyId < 729) {
      return 'پارس خودرو'
    } else if (companyId === 729 || companyId < 737) {
      return 'چانگان'
    } else if (companyId === 737 || companyId < 743) {
      return 'دوو'
    } else if (companyId === 743 || companyId < 748) {
      return 'بایک'
    } else if (companyId === 748 || companyId < 759) {
      return 'فونیکس'
    } else if (companyId === 759 || companyId < 769) {
      return 'فردا'
    } else if (companyId === 769 || companyId < 774) {
      return 'لاماری'
    } else if (companyId === 774 || companyId < 779) {
      return 'ریگان'
    } else if (companyId === 779 || companyId < 783) {
      return 'بیسو'
    } else if (companyId === 783 || companyId < 789) {
      return 'بی وای دی'
    } else if (companyId === 789 || companyId < 792) {
      return 'دامای'
    } else if (companyId === 792 || companyId < 796) {
      return 'بورگوارد'
    } else if (companyId === 796 || companyId < 800) {
      return 'هن تنگ'
    } else if (companyId === 800 || companyId < 804) {
      return 'یوآز'
    } else if (companyId === 804 || companyId < 813) {
      return 'هاوال'
    } else if (companyId === 813 || companyId < 817) {
      return 'اس دبلیو ام'
    } else if (companyId === 817 || companyId < 827) {
      return 'فولکس'
    } else if (companyId === 827 || companyId < 841) {
      return 'نیسان'
    } else if (companyId === 841 || companyId < 890) {
      return 'میتسوبیشی'
    } else if (companyId === undefined) {
      return 'ثبت نشده'
    }
  }
  const getCarCompanyTitle = (companyId: string) => {
    switch (companyId) {
      case '1':
        return 'سایپا'

      case '2':
        return 'ایرانخودرو'
      case '3':
        return 'بهمن'
      case '4':
        return 'ام وی ام'
      case '5':
        return 'چری'
      case '6':
        return 'دانگ فنگ'
      case '7':
        return 'بی ام و'
      case '8':
        return 'جیلی'
      case '9':
        return 'فاو'
      case '10':
        return 'گریت وال'
      case '11':
        return 'کرمان موتور'
      case '12':
        return 'فوتون'
      case '13':
        return 'رنو'
      case '14':
        return 'پژو'
      case '15':
        return 'آسنا'
      case '16':
        return 'جک'
      case '17':
        return 'مزدا'
      case '18':
        return 'لیفان'
      case '19':
        return 'سانگ یانگ'
      case '20':
        return 'تویوتا'
      case '21':
        return 'زامیاد'
      case '22':
        return 'Huang Hia '
      case '23':
        return 'کیا'
      case '24':
        return 'پروتون'
      case '25':
        return 'هیوندا'
      case '26':
        return 'سیتروئن'
      case '27':
        return 'مرسدس بنز'
      case '28':
        return 'ام جی'
      case '29':
        return 'هایما'
      case '30':
        return 'سوزوکی'
      case '31':
        return 'پارس خودرو'
      case '32':
        return 'چانگان'
      case '33':
        return 'دوو'
      case '34':
        return 'بایک'
      case '35':
        return 'فونیکس'
      case '36':
        return 'فردا'
      case '37':
        return 'لاماری'
      case '38':
        return 'ریگان'
      case '39':
        return 'بیسو'
      case '40':
        return 'بی وای دی'
      case '41':
        return 'دامای'
      case '42':
        return 'بورگوارد'
      case '43':
        return 'هن تنگ'
      case '44':
        return 'یوآز'
      case '45':
        return 'هاوال'
      case '46':
        return 'اس دبلیو ام'
      case '47':
        return 'فولکس'
      case '48':
        return 'نیسان'
      case '49':
        return 'میتسوبیشی'

      default:
        return ''
    }
  }
  // تابع تبدیل تاریخ شمسی به میلادی

  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  // تابع نمایش وضیعت دستگاه

  const getDeviceStatus = () => {
    if (onStatus?.isOn === true) {
      return <CircleRoundedIcon sx={{ color: 'green', alignItems: 'center' }} />
    } else if (onStatus?.isOn === false && onStatus?.lastOffAlarmTime === null) {
      return <ReportRoundedIcon sx={{ color: 'orange', alignItems: 'center' }} />
    } else if (onStatus?.isOn === false) {
      return (
        <Typography
          sx={{
            ...(onStatus?.lastOffAlarmTime !== null && {
              color: 'red',
              fontSize: '12px',
            }),
          }}
        >
          {shamsi(onStatus?.lastOffAlarmTime)}
        </Typography>
      )
    }
  }
  // اطلاعات مربوط به ریسئانسیو صفحه

  const matches = useMediaQuery(' (max-width:900px)')
  const matches1 = useMediaQuery(' (min-width:600px)')

  return (
    <Card
      dir='ltr'
      sx={{
        marginBottom: '2px',
        height: 1,
        maxHeight: 1,
        background:
          themeApp === 'dark' ? theme.palette.common.white : darkTheme.palette.common.white,
      }}
    >
      <CardActionArea
        onClick={() => {
          if (car !== undefined) navigate(`/${routes.CARS}/${id}`, { state: { id, car } })
          dispatch(getLastPosition(id))
          dispatch(getDevice(id))
        }}
      >
        <CardHeader
          avatar={<Avatar src={getCarCompany(car.model)} />}
          // subheader={car.modelName}
          sx={{
            p: 1,
            direction: 'rtl',
            '& .MuiCardHeader-avatar': { marginRight: 1 },
            '& .MuiTypography-root': { marginRight: 1, fontSize: 18 },
            '& .MuiCardHeader-title': { fontSize: 18 },
          }}
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions

          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          title={`${getCarCompany1(car.model)} ${getCarCompany1(car.model) && '-'} ${
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            car.modelName !== undefined ? car.modelName : 'ثبت نشده'
          } `}
        />

        <Box sx={{ direction: 'rtl', display: 'flex', p: 1, alignItems: 'center' }}>
          <PersonPinIcon />
          <Typography>{car?.nameLname === undefined ? 'ثبت نشده' : car?.nameLname}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: 1,
            width: '100%',
            alignItems: 'center',
          }}
        >
          <NumberPlate
            first={car?.numberPlate?.split('-')[0]}
            forth={car?.numberPlate?.split('-')[3]}
            second={car?.numberPlate?.split('-')[1]}
            third={car?.numberPlate?.split('-')[2]}
          />
          <Box
            alignItems={'center'}
            display='flex'
            justifyContent='center'
            sx={{
              ...(onStatus?.lastOffAlarmTime !== null && {
                display: 'flex',
                flexDirection: 'column-reverse',
                alignItems: 'center',
              }),
            }}
          >
            <Typography alignItems={'center'} component={'span'}>
              {getDeviceStatus()}
            </Typography>
            {onStatus?.lastOffAlarmTime === null ? (
              <Typography>:وضیعت</Typography>
            ) : (
              <Typography sx={{ fontSize: matches && matches1 ? '9px' : '11px' }}>
                :آخرین زمان روشن بودن
              </Typography>
            )}
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default CarItem
